import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const TenantHome = () => {
  const [rent, setRent] = useState('');
  const [deposit, setDeposit] = useState('');
  const [tenancyStart, setTenancyStart] = useState('');
  const [tenancyEnd, setTenancyEnd] = useState('');
  const { user } = useAuth(); // get user from context

  const loadTenantHome = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/tenancy-details`, {
        method: 'POST',
        headers: {'Content-Type' : 'application/json'},
        body: JSON.stringify({user_id: user.id})
      });
      const result = await response.json();
      
      if (response.ok) {
        setRent(result.rent);
        setDeposit(result.deposit);
        setTenancyStart(result.tenancy_start);
        setTenancyEnd(result.tenancy_end);
      } else {
        console.error(result.error);
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  };

  useEffect(() => {
    if (user && user.id) {
      loadTenantHome();
    }
  }, [user]);

  return (
    <div>
      <h1>Welcome Tenant Home</h1>
      <p>Here’s a summary of your tenancy status:</p>

      <section>
        <h3>Pending Bills</h3>
        <ul>
          <li>Rent: £{rent} - Due monthly between: {tenancyStart} - {tenancyEnd}</li>
          <li>Deposit: £{deposit} - Due by: {tenancyStart}</li>
        </ul>
      </section>

      <section>
        <h3>In Progress Issues</h3>
        <ul>
          <li>Leaking kitchen tap - Reported: Oct 5, 2025</li>
          <li>Wi-Fi disruption - Reported: Oct 6, 2025</li>
        </ul>
      </section>
    </div>
  );
};

export default TenantHome;
